export const lgyLangId = {
    ticketLgy: {
        AuditResult: 'Audit Result',
        ExcepQuestion: 'Abnormal Problems',
        ExcepAnswer: 'Exception Option',
        TicketsTotal: 'Tickets Total',
        Invalid:'Tidak Valid',
        Effected:'Efektif',
        Unblock:'Tidak Diblokir',
        Status:'Status User',
        Normal:'Normal',
        invalid:'Tidak Valid',
        Block:'Blokir',
        Success:'Sukses',
        Failed:'Gagal',
        TicketTag:'Label Tiket',
        PartialCompletionTime:'Waktu Parsial Selesai',
        GoogleVerification:'Verifikasi Google',
        Active:'Aktif',
        Di:'Tidak Aktif',
        Outsourcingornot:'Tipe User',
        LocalCollection:'Penagihan Internal',
        Outsourcing:'Pihak ketiga',
        All:'Semua',
        PhoneVerify:'Verifikasi telepon',
        plschoose:'Silahkan pilih',
        plsinputID:'Mohon masukkan ID',
        TotalRepayment:'Total Pembayaran',
        UserRepaymentIntoAccount:'Pembayaran user masuk ke rekening',
        UserRpaymentTime:'Waktu pembayaran masuk ke rekening',
        Rollover:'Perpanjangan',
        RolloverTime:'waktu pembayaran perpanjangan masuk',
        CouponCredited:'Kupon masuk ke rekening',
        CouponCreditTime:'Waktu kupon masuk ke rekening',
        DeductionCredited:'Potongan masuk ke rekening',
        DeductionCreditedTime:'waktu potongan masuk ke rekening',
        OtherEntry:'Pemasukan lainnya',
        OtherEntryTime:'waktu pemasukan lainnya',
        ButtonManagement:'pengelolaan tombol',
        ListManagement:'daftar Pengelolaan',
        Button:'tombol',
        Authority:'Kewenangan',
        Add:'tambah',
        Edit:'edit',
        Delete:'hapus',
        RouteList:'daftar rute',
        addaFirstLevelPage:'Halaman Penambahan 1 tingkat',
        Save:'simpan',
        AddCallList:'tambahkan daftar telepon',
        ListOrderConfiguration:'Daftar urutan konfigurasi ',
        ListOrder:'daftar urutan',
        ListList:'daftar list',
        AutoDial:'autodial',
        Stop:'pemberhentian auto dial',
        DialID:'dial ID',
        NextCallTime:'waktu panggil selanjutnya',
        Approve:'setuju',
        Fail:'gagal',
        Invalidation:'tidak valid',
        RejectAnApplication:'pinjaman ditolak',
        BasicInformation:'informasi dasar',
        ManualReview:'verifikasi manual',
        PhoneReview:'verifikasi telepon',
        ContactInformationAudit:'verifikasi informasi kontak darurat',
        CustomerInformationAudit:'verifikasi informasi nasabah',
        AuditCompleted:'verifikasi selesai',
        LaterProcessing:'Diproses nanti',
        Male:'pria',
        Female:'wanita',
        Secrecy:'menjaga rahasia',
        OutCall:'panggilan keluar',
        SaveCallLog:'simpan catatan panggilan',
        DialingMethod:'metode panggilan',
        InSystem:'di dalam sistem',
        OutsideSystem:'di luar sistem',
        QualityInspectionResults:'hasil pemeriksaan',
        QualityInspectionNotes:'catatan pemeriksaan',
        TelemarketingDistribution:'pembagian telemarketing',
        OrderTag: "Label Tiket",

    },
    formLgy: {
        Supplier:'supplier',
        ExtensionNumber:'Nomor ekstensi',
        Name:'Nama',
        RoleList:'Daftar role',
        TicketCategory:'tiket kategori',
        QueryDimension:'dimensi pertanyaan',
        Date:'tanggal',
        Coupon:'kupon',
        ButtonSelection:'pilihan tombol',
        Routing:'Pilihan rute',
        Aging:'Buket',
        QueueSorting:'sortir antrian',
        ListCallOrder:'daftar urutan panggilan',
        TicketMaxWorkingNumberHistory:'riwayat maksimum tiket staff',
        EffectiveDate:'waktu efektif',
        TicketCrowdRoleGroup:'Penerima Tiket (Role Team)',
        TicketCrowdRoleGroup2:'Role Team:',
        TotalTickets: "工单总量:",
        LeftTicket:'分配后剩余单量:',       
        orderTags: '标签',
    },
    tableLgy: {
        AverageCallVolume:'rata rata total penelponan',
        AverageConnectionAmount:'rata rata jumlah terhubung',
        EmployeeRole:'role staff',
        Leader:'Leader',
        Groupleader:'Grup Leader',
        ConnectedRate:'persentase terhubung',
        CallMedian:'Rata - rata median panggilan',
        RegistrationTime:'waktu registrasi',
        LastLoginTime:'waktu login terakhir',
        PageName:'nama halaman',
        ButtonBame:'nama tombol',
        RouteName:'nama rute',
        Route:'rute',
        Value:'nilai',
        AutoCall:'Autocall',
        ManualCall:'penelponan manual',
        CallMode:'mode penelponan',
        RuleNumber:'nomor aturan',
        RuleName:'nama aturan',
        RuleDetails:'detail aturan',
    },
    menuLgy: {
        ResultStatistics:'Laporan statistik hasil pengingat',
        OverdueReasonStat:'Laporan statistik alasan terlambat',
        CallRecordData:'data laporan penelponan',
        CollectionPerformanceDetails:'detail hasil penagihan',
        SelectCouponTemplate:'silahkan pilih template kupon',
        PageManagement:'halaman pengelolaan',
        RouteManagement:'Rute pengelolaan',
        MenuList:'daftar menu',
        MenuDetails:'detail menu',
        CallSequenceConfiguration:'konfigurasi urutan penelponan',
        EmployeeReviewDetails:'detail verifikasi staff',
        CustomerInformation:'informasi nasabah',
        Audit:'verifikasi',
        DistributionRules:'pembagian tiket marketing',
    },
    tipsLgy: {
        EnterPageName:'silahkan masukan nama halaman',
        EnterRouteName:'silahkan pilih nama rute',
        ConfirmDelete:'konfirmasi hapus',
        EnterRouteValue:'silahkan pilih nilai rute',
        SelectButton:'silahkan pilih tombol',
        SelectRoute:'silahkan pilih rute',
        CallSequenceConfiguration:'konfigurasi urutan penelponan',
        EnterNumber:'silahkan masukan angka',
        NotPTPAndNextCallTime:'jangan masukan waktu ptp dan waktu penelponan selanjutnya di waktu yang bersamaan',
        NextCallTimeTips:'jika sudah menyimpan PTP, jangan diisi lagi',
        SelectPerson:'silahkan pilih nomor tujuan',
        SelectCallTime:'silahkan pilih waktu penelponan',
        SelectWhetherConnect:'silahkan pilih terhubung atau tidak',

    }
};
